import React from 'react'
import {Table, Thead, Th, Tr, Td} from 'components/reactable'
import NoResults from 'components/noResults'
import DateValue from 'elements/DateValue'
import rt from 'components/reactable.scss'

import i18n from 'lib/i18n'
const _ = i18n('adminDocs')

const OfficeAdminDom = ({children}) => {
	return (
		<div>
			{children && children.length > 0 ? (
				<div className={rt.tableContainer}>
					<Table
						className="table"
						itemsPerPage={7}
						filterPlaceholder={_('placeholder')}
						filterable={['documentType', 'documentDate']}
						noDataText={<NoResults type="adminDocs"/>}
						sortable={[
							'documentId',
							{
								column: 'documentDate',
								sortFunction: 'Date',
							},
							'documentType',
						]}
						defaultSort={{
							column: 'documentDate',
							direction: 'desc',
						}}
					>
						<Thead>
							<Th column="documentIcon" label=""/>
							<Th column="documentType">
								<strong>{_('type')}</strong>
							</Th>
							<Th
								column="documentDate"
								className={rt.date}
							>
								<strong>{_('date')}</strong>
							</Th>
						</Thead>
						{children.map(item => (
							<Tr
								onClick={() => window.open(`/data/document?id=${item.documentId}`, '_blank', 'noopener,noreferrer')}
								className="clickable centered docRow"
								key={item.documentId}
							>
								<Td column="documentIcon">
									<div className="rowIcon">
										<img src={require('resources/images/pdf-icon_1x.png')}/>
									</div>
								</Td>
								<Td
									column="documentType"
									data={_(`ora:adminDocs_${item.documentType}`)}
								/>
								<Td
									column="documentDate"
									value={item.documentDate}
								>
									<DateValue date={item.documentDate}/>
								</Td>
							</Tr>
						))}
					</Table>
				</div>
			) : (
				<NoResults type="adminDocs"/>
			)}
		</div>
	)
}

export default OfficeAdminDom



// WEBPACK FOOTER //
// ./elements/OfficeAdminDom.jsx